const experiences = [
  '0 - 1 years',
  '1 - 2 years',
  '2 - 5 years',
  '5 - 10 years',
  '10 - 15 years',
  '15+ years',
];
export default experiences;
